<template>
            <BreadCrumb PageTitle=" Liste des paiements" />
    <ListePaiement/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import ListePaiement from "@/components/Paiement/ListePaiement.vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  
    export default defineComponent({
      name: "ListePaiementPage",
      components: {
        ListePaiement,
        BreadCrumb
      },
    });
  </script>